import { Button, Card, Col, Row, Table } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle, faPlayCircle } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import MockService from '../../../../Services/MockService';
import LiveExam from '../../../../Services/liveexam.services';
import { errorResponseHelper } from '../../../../helpers/request.helper';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';

interface IOngoing {
    exams: any[]
}

export default function Ongoing({ exams }: IOngoing) {

    const navigate = useNavigate();
    const [startExamId, setStartExamId] = useState<string>("")

    const generateTokenForLiveExam = async (examId:string, mappingId:string) => {
        await LiveExam.generateTokenForLiveExam(examId, mappingId).then((res) => {
            if (res.status === 200) {
                sessionStorage.setItem("liveToken", res.data.data.token);
                toast.success("Exam CountDown Has begun");
                navigate('/live/exam-live', { state: { examId: examId, mappingId: mappingId } });
            }
        }).catch(e => {
            errorResponseHelper(e)
        })
    }
    
    const startExam = async (data:any) => {

        await MockService.startExamByExamId(data)
            .then(async (res) => {
                if(res.status === 200){
                    const resData = res.data?.data;
                    if(resData){
                        sessionStorage.setItem("liveToken", resData.token);
                        setStartExamId(resData.responses?._id);
                        navigate('/exam/instructions', { state: { examId: data, mappingId: resData.responses?.mapping } });
                    }
                }
            })
            .catch((err) => {
                toast.error(err.response?.data || 'Something went wrong');
                console.error(err);
            })
    }

    return (
        <Row>
            <Col>
                <Card className="dcm-exam-list-card">
                    <Card.Header>
                        <div className="d-flex justify-content-start align-items-center gap-2">
                            Exams Live
                            <FontAwesomeIcon icon={faCircle} className="text-success" style={{ fontSize: 10 }} />
                        </div>
                    </Card.Header>
                    <Card.Body>
                        {exams.length === 0 ? (
                            <p className="text-muted text-center py-3">No live exams available.</p>
                        ) : (
                            <Table borderless hover responsive className="">
                                <thead>
                                    <tr>
                                        <th>Icon</th>
                                        <th>Exam Name</th>
                                        <th>Subject</th>
                                        <th>Exam ID</th>
                                        <th>Start Time</th>
                                        <th>End Time</th>
                                        <th>Duration</th>
                                        <th>Remaining</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {exams.map((exam: any, index: number) => {
                                        if (!exam.userShow) return null;

                                        const start = moment(exam.startTime);
                                        const end = moment(exam.endTime);
                                        const duration = end.diff(start, 'minutes');
                                        const remaining = end.diff(moment(), 'minutes');

                                        return (
                                            <tr key={index} className="dcm-table-row-card">
                                                <td>
                                                    {exam.icon && (
                                                        <img
                                                            src={exam.icon}
                                                            alt="icon"
                                                            style={{ width: 40, height: 40, objectFit: 'cover', borderRadius: 4 }}
                                                        />
                                                    )}
                                                </td>
                                                <td className="fw-bold fs-12">{exam.examName}</td>
                                                <td className="fs-12">{exam.subject}</td>
                                                <td className="fs-12 text-muted">{exam.examId}</td>
                                                <td className="fs-12">{start.format('DD MMM YYYY, hh:mm A')}</td>
                                                <td className="fs-12">{end.format('DD MMM YYYY, hh:mm A')}</td>
                                                <td className="fs-12 text-primary fw-bold">{duration} mins</td>
                                                <td className="fs-12 fw-bold">
                                                    {remaining <= 0 ? (
                                                        <span className="text-danger">Ended</span>
                                                    ) : (
                                                        <span className="text-success">{remaining} mins</span>
                                                    )}
                                                </td>
                                                <td>
                                                    <Button
                                                        variant={exam.startAllowed ? 'success' : 'secondary'}
                                                        size="sm"
                                                        className="fs-10"
                                                        disabled={!exam.startAllowed}
                                                        onClick={() => startExam(exam._id)}
                                                    >
                                                        Read Instructions & Start Exam{' '}
                                                        <FontAwesomeIcon icon={faPlayCircle} />
                                                    </Button>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>
                        )}
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    );
}
